import { useState, useEffect } from "react";
import { Container, Row, Col, Card, Form, Button } from "react-bootstrap";
import { FaEye, FaEyeSlash, FaUser, FaLock } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import img12 from "../assets/bgimg.png";
import logo from "../assets/logo.png";

import { authLogin } from "../store/slices/auth";
import { useDispatch, useSelector } from "react-redux";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function AdminLogin() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { loading, error, user } = useSelector((state) => state.auth);

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});

  const handleSubmit = (e) => {
    e.preventDefault();

    const newErrors = {};

    if (!username.trim()) {
      newErrors.username = "Please enter your username";
    }

    if (!password.trim()) {
      newErrors.password = "Please enter your password";
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      dispatch(authLogin({ username, password }));
    }
  };

  useEffect(() => {
    if (!user) return;

    navigate("/superadmin/home", { replace: true });
  }, [user, navigate]);

  useEffect(() => {
    if (error) {
      toast.error(error);
    }
  }, [error]);

  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundImage: `url(${img12})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div
        style={{
          minHeight: "100vh",
          backdropFilter: "blur(6px)",
          backgroundColor: "rgba(0,0,0,0.25)",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Container>
          <Row className="justify-content-center">
            <Col lg={5} md={7} sm={10}>
              <Card className="shadow" style={{ borderRadius: "20px" }}>
                <Card.Body className="p-4">
                  {/* Logo */}
                  <div className="text-center mb-3">
                    <img
                      src={logo}
                      alt="App Logo"
                      className="img-fluid"
                      style={{
                        maxWidth: "250px",
                        width: "100%",
                      }}
                    />
                  </div>

                  <h5 className="fw-bold mb-2 text-center purple-color">
                    Login
                  </h5>

                  <p className="text-muted text-center mb-4">
                    Access with your credentials
                  </p>

                  <Form onSubmit={handleSubmit}>
                    {/* Username */}
                    <Form.Group className="mb-3">
                      <Form.Label>Username</Form.Label>
                      <div className="position-relative">
                        <Form.Control
                          type="text"
                          placeholder="Enter username"
                          value={username}
                          onChange={(e) => setUsername(e.target.value)}
                        />
                      </div>
                      {errors.username && (
                        <small className="text-danger">{errors.username}</small>
                      )}
                    </Form.Group>

                    {/* Password */}
                    <Form.Group className="mb-3">
                      <Form.Label>Password</Form.Label>
                      <div className="position-relative">
                        <Form.Control
                          type={showPassword ? "text" : "password"}
                          placeholder="Enter password"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                        />
                        <span
                          className="position-absolute top-50 end-0 translate-middle-y me-3"
                          style={{ cursor: "pointer" }}
                          onClick={() => setShowPassword(!showPassword)}
                        >
                          {showPassword ? (
                            <FaEye className="purple-color" />
                          ) : (
                            <FaEyeSlash className="purple-color" />
                          )}
                        </span>
                      </div>
                      {errors.password && (
                        <small className="text-danger">{errors.password}</small>
                      )}
                    </Form.Group>

                    <div className="text-end mb-3">
                      <a
                        href="/forgotpassword"
                        className="text-decoration-none purple-color"
                      >
                        Forgot password?
                      </a>
                    </div>

                    <Button
                      disabled={loading}
                      type="submit"
                      className="w-100"
                      style={{
                        backgroundColor: "#1e0959",
                        border: "none",
                        borderRadius: "30px",
                        padding: "10px",
                      }}
                    >
                      {loading ? "Logging in..." : "Login"}
                    </Button>

                    {/* <div className="text-center mt-3">
                                            Don’t have an account?
                                            <a
                                                href="/signup"
                                                className="text-decoration-none fw-semibold purple-color"
                                            >
                                                Sign up
                                            </a>
                                        </div> */}
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
}
